import { BaseController } from '../../../../../common/base/controller';

import _ from 'lodash';

export class IbanValidationController extends BaseController {
  constructor(controllerService, pdfViewerService, $scope) {
    'ngInject';
    super({ controllerService, pdfViewerService, $scope });
  }

  $onInit() {
    this.setupErrors();
    this.setupValidation();
  }

  setupValidation() {
    this.$scope.$watch('vm.model.checkSumNewIban', (val) => {
      const newIbanStart = this.newIban.slice(2, 4);
      const newIbanStartValid = newIbanStart === val;
      if (!this.form.checkSumNewIban) return;
      this.form.checkSumNewIban.$setValidity('invalid', newIbanStartValid);
      this.checkAllValid();
    });

    this.$scope.$watch('vm.model.lastDigitsNewIban', (val) => {
      const newIbanEnd = this.newIban.slice(-6);
      const newIbanEndValid = newIbanEnd === val;
      if (!this.form.lastDigitsNewIban) return;
      this.form.lastDigitsNewIban.$setValidity('invalid', newIbanEndValid);
      this.checkAllValid();
    });

    this.$scope.$watch('vm.model.lastDigitsOldIban', (val) => {
      const lastTenDigits = this.oldIban.slice(-10);
      const regex = new RegExp(`^\\d{0,4}${val}$`, 'gm');
      const oldIbanEndValid = regex.test(lastTenDigits);

      if (!this.form.lastDigitsOldIban) return;
      this.form.lastDigitsOldIban.$setValidity('invalid', oldIbanEndValid);
      this.checkAllValid();
    });
  }

  checkAllValid() {
    this.onValid({ $event: _.isEmpty(this.form.$error) });
  }

  setupErrors() {
    this.checkSumMessages = {
      required: 'app.waitForTransferring.validation.required',
      invalid: 'app.waitForTransferring.validation.chechsum.invalid',
    };

    this.lastDigitsNewIbanMessages = {
      required: 'app.waitForTransferring.validation.required',
      invalid: 'app.waitForTransferring.validation.newIban.invalid',
    };

    this.lastDigitsOldIbanMessages = {
      required: 'app.waitForTransferring.validation.required',
      invalid: 'app.waitForTransferring.validation.oldIban.invalid',
    };
  }
}
